import React from "react";

const Information: React.FC = () => <p className={"z-20 fixed hdhoch:bottom-12 wqhdhoch:bottom-24 hdhoch:right-12 wqhdhoch:right-24 text-white hdhoch:text-[18px] wqhdhoch:text-[30px] wqhdquer:text-[50px]"}>Bei Fragen zu Allergenen und Zusatzstoffen wenden Sie sich bitte an unser Küchenpersonal</p>

export default Information;